import React from 'react';
import { Table, Form, Button } from 'react-bootstrap';
import LogTimeDescription from './LogTimeDescription';

const TimesheetsTable = ({
    onEdit,
    onMoveOrCopy,
    onLogTime,
    onViewHistory,
    onAddSubtasks,
    onView,
    onDuplicate,
    onDelete,
    onEstimateTime
}) => {
    const [expandedRows, setExpandedRows] = React.useState(new Set());
    const [showLogModal, setShowLogModal] = React.useState(false);
    const [selectedTime, setSelectedTime] = React.useState('');
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [selectedTaskId, setSelectedTaskId] = React.useState(null);

    const validateTimeFormat = (value) => {
        if (!value) return true; // Allow empty value
        
        const matches = value.toLowerCase().match(/^(?:(\d+)h\s*)?(?:(\d+)m)?$/);
        if (!matches) return false;

        const hours = parseInt(matches[1] || 0);
        const minutes = parseInt(matches[2] || 0);

        // Ensure minutes are less than 60
        if (minutes >= 60) return false;

        // Ensure at least one value is provided
        return hours > 0 || minutes > 0;
    };

    const formatTime = (value) => {
        const matches = value.toLowerCase().match(/^(?:(\d+)h\s*)?(?:(\d+)m)?$/);
        if (!matches) return '';

        const hours = parseInt(matches[1] || 0);
        const minutes = parseInt(matches[2] || 0);

        let formattedTime = '';
        if (hours > 0) formattedTime += `${hours}h`;
        if (hours > 0 && minutes > 0) formattedTime += ' ';
        if (minutes > 0) formattedTime += `${minutes}m`;
        return formattedTime;
    };

    const handleTimeInput = (e, taskId, date) => {
        const value = e.target.value.trim();
        
        if (validateTimeFormat(value)) {
            e.target.classList.remove('is-invalid');
            if (value) {
                const formattedTime = formatTime(value);
                e.target.value = formattedTime; // Update input with formatted value
                setSelectedTime(formattedTime);
                setSelectedDate(date);
                setSelectedTaskId(taskId);
                e.target.blur(); // Remove focus from the input
                setShowLogModal(true);
            }
        } else {
            e.target.classList.add('is-invalid');
            e.target.value = ''; // Clear invalid input
        }
    };

    const toggleRow = (index) => {
        const newExpandedRows = new Set(expandedRows);
        if (newExpandedRows.has(index)) {
            newExpandedRows.delete(index);
        } else {
            newExpandedRows.add(index);
        }
        setExpandedRows(newExpandedRows);
    };
    return (
        <React.Fragment>
            <Table responsive className='c-table'>
                <thead>
                    <tr>
                        <th width="50px" className='text-center'>
                            <Form.Check />
                        </th>
                        <th>Task</th>
                        <th width="150px" className='text-center'>Estimated Time</th>
                        <th width="150px" className='text-center'>Mon - Aug 11</th>
                        <th width="150px" className='text-center'>Tue - Aug 12</th>
                        <th width="150px" className='text-center'>Wed - Aug 13</th>
                        <th width="150px" className='text-center'>Thu - Aug 14</th>
                        <th width="150px" className='text-center'>Fri - Aug 15</th>
                        <th width="150px" className='text-center'>Week total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colSpan={3}></td>
                        <td className='text-center fw-bold'>8h 30m</td>
                        <td className='text-center fw-bold'>8h 30m</td>
                        <td className='text-center fw-bold'>8h 30m</td>
                        <td className='text-center fw-bold'>8h 30m</td>
                        <td className='text-center fw-bold'>8h 30m</td>
                        <td></td>
                    </tr>
                    {[...Array(5)].map((_, i) => (
                        <React.Fragment key={i}>
                            <tr>
                                <td className='text-center'>
                                    <Form.Check />
                                </td>
                                <td>
                                    <div className='d-flex align-items-center'>
                                        <Button variant="link" className='me-3' onClick={() => toggleRow(i)}>
                                            <i className={`fas fa-chevron-${expandedRows.has(i) ? 'down' : 'right'}`}></i>
                                        </Button>
                                        <div className='d-flex flex-column align-items-start'>
                                            <div className='p-tag fw-bold'>Home Page</div>
                                            <div className='p-tag'>Backend Tasks</div>
                                        </div>
                                    </div>
                                </td>
                                <td 
                                    className='text-center' 
                                    onClick={onEstimateTime}
                                >
                                    12h 30m
                                </td>
                                <td className='text-center fw-bold'>
                                    <Form.Control 
                                        type="text" 
                                        className='text-center'
                                        placeholder="1h 30m"
                                        onBlur={(e) => handleTimeInput(e, i, 'Aug 11')}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleTimeInput(e, i, 'Aug 11');
                                            }
                                        }}
                                    />
                                </td>
                                <td className='text-center fw-bold'>
                                    <Form.Control 
                                        type="text" 
                                        className='text-center'
                                        placeholder="1h 30m"
                                        onBlur={(e) => handleTimeInput(e, i, 'Aug 12')}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleTimeInput(e, i, 'Aug 12');
                                            }
                                        }}
                                    />
                                </td>
                                <td className='text-center fw-bold'>
                                    <Form.Control 
                                        type="text" 
                                        className='text-center'
                                        placeholder="1h 30m"
                                        onBlur={(e) => handleTimeInput(e, i, 'Aug 13')}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleTimeInput(e, i, 'Aug 13');
                                            }
                                        }}
                                    />
                                </td>
                                <td className='text-center fw-bold'>
                                    <Form.Control 
                                        type="text" 
                                        className='text-center'
                                        placeholder="1h 30m"
                                        onBlur={(e) => handleTimeInput(e, i, 'Aug 14')}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleTimeInput(e, i, 'Aug 14');
                                            }
                                        }}
                                    />
                                </td>
                                <td className='text-center fw-bold'>
                                    <Form.Control 
                                        type="text" 
                                        className='text-center'
                                        placeholder="1h 30m"
                                        onBlur={(e) => handleTimeInput(e, i, 'Aug 15')}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleTimeInput(e, i, 'Aug 15');
                                            }
                                        }}
                                    />
                                </td>
                                <td className='text-center fw-bold'>12h 30m</td>
                            </tr>
                            {expandedRows.has(i) && (
                                <React.Fragment>
                                    {[...Array(3)].map((_, j) => (
                                        <React.Fragment key={`${i}-${j}`}>
                                            <tr className='sub-row'>
                                                <td className='text-center'>
                                                    <Form.Check />
                                                </td>
                                                <td>
                                                    I have reviewed the code and submitted it to the development team.
                                                </td>
                                                <td className='text-center'></td>
                                                <td className='text-center fw-bold'>
                                                    <Form.Control 
                                                        type="text" 
                                                        className='text-center'
                                                        placeholder="1h 30m"
                                                        onBlur={(e) => handleTimeInput(e, `${i}-sub-${j}`, 'Aug 11')}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                handleTimeInput(e, `${i}-sub-${j}`, 'Aug 11');
                                                            }
                                                        }}
                                                    />
                                                </td>
                                                <td className='text-center fw-bold'>
                                                    <Form.Control 
                                                        type="text" 
                                                        className='text-center'
                                                        placeholder="1h 30m"
                                                        onBlur={(e) => handleTimeInput(e, `${i}-sub-${j}`, 'Aug 12')}
                                                    />
                                                </td>
                                                <td className='text-center fw-bold'>
                                                    <Form.Control 
                                                        type="text" 
                                                        className='text-center'
                                                        placeholder="1h 30m"
                                                        onBlur={(e) => handleTimeInput(e, `${i}-sub-${j}`, 'Aug 13')}
                                                    />
                                                </td>
                                                <td className='text-center fw-bold'>
                                                    <Form.Control 
                                                        type="text" 
                                                        className='text-center'
                                                        placeholder="1h 30m"
                                                        onBlur={(e) => handleTimeInput(e, `${i}-sub-${j}`, 'Aug 14')}
                                                    />
                                                </td>
                                                <td className='text-center fw-bold'>
                                                    <Form.Control 
                                                        type="text" 
                                                        className='text-center'
                                                        placeholder="1h 30m"
                                                        onBlur={(e) => handleTimeInput(e, `${i}-sub-${j}`, 'Aug 15')}
                                                    />
                                                </td>
                                                <td className='text-center fw-bold'>12h 30m</td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </Table>
            <LogTimeDescription 
                show={showLogModal}
                onHide={() => {
                    setShowLogModal(false);
                    setSelectedTime('');
                    setSelectedDate(null);
                    setSelectedTaskId(null);
                }}
                onSubmit={(description) => {
                    onLogTime({
                        taskId: selectedTaskId,
                        date: selectedDate,
                        time: selectedTime,
                        description
                    });
                    setShowLogModal(false);
                    setSelectedTime('');
                    setSelectedDate(null);
                    setSelectedTaskId(null);
                }}
            />
        </React.Fragment>
    );
};

export default TimesheetsTable;
